import { anyApi, type ApiFromModules } from "convex/server";
import type * as roasteries from "./convex/labs/roasteries";
import type * as inventory from "./convex/labs/inventory";
import type * as quality from "./convex/labs/quality";
import type * as recordings from "./convex/labs/recordings";
import type * as blends from "./convex/labs/blends";

// Scope frontend inference to the roasting feature's registered modules. Importing the full
// commerce API pulls every backend implementation into the roasting feature types.
type LabsApi = ApiFromModules<{
  "labs/roasteries": typeof roasteries;
  "labs/inventory": typeof inventory;
  "labs/quality": typeof quality;
  "labs/recordings": typeof recordings;
  "labs/blends": typeof blends;
}>;
export const api = anyApi as unknown as LabsApi;
